import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'

import Button from '@eig-builder/core-ui/Button'
import TextField from '@eig-builder/core-ui/TextField'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'
import usePostAsJson from '@eig-builder/core-utils/hooks/usePostAsJson'

import Modal from 'core/components/modal'

import { getCrmApiOptions } from '../../../helpers/fetch-options-helper'
import { loadAccountById } from '../../../store/actions'

import Text from '@eig-builder/module-localization'
import ButtonWithLoader from '../../../../../core/components/button-with-loader'

const styles = theme => ({
  field: {
    marginTop: theme.spacing(2)
  },
  actions: {
    margin: theme.spacing(5),
    marginTop: 0
  }
})

const ChangeNameDialog = ({ classes, handleDialog, open }) => {
  const [firstName, setFirstName] = useState('')
  const [firstNameError, setFirstNameError] = useState('')
  const [lastName, setLastName] = useState('')
  const [lastNameError, setLastNameError] = useState('')

  const account = useSelector(state => state.crm.getAccountByIdResponse)

  const [state, doRequest] = usePostAsJson()

  const dispatch = useDispatch()

  useEffect(() => {
    if (state.status === 200) {
      dispatch(loadAccountById(account.partnerId, account.id))
    }
  }, [state.status])

  const onFirstNameChange = e => {
    setFirstName(e.target.value)

    if (firstNameError) {
      setFirstNameError('')
    }
  }

  const onLastNameChange = e => {
    setLastName(e.target.value)

    if (lastNameError) {
      setLastNameError('')
    }
  }

  const onSubmit = e => {
    e.preventDefault()

    let valid = true
    if (!firstName) {
      valid = false
      setFirstNameError('First name can not be empty')
    }
    if (!lastName) {
      valid = false
      setLastNameError('Last name can not be empty')
    }
    if (valid) {
      const body = {
        first_name: firstName,
        last_name: lastName
      }

      const apiOptions = getCrmApiOptions(account, '/v1.0/account/change-name', 'text')

      doRequest(body, apiOptions)
    }
  }

  const actions = [
    <Button
      key='change-name-cancel'
      color='secondary'
      disabled={state.isLoading}
      onClick={handleDialog}
      dataElementLocation={DataElementLocations.BODY}
      dataElementLabel='cst-account-details-change-name-cancel'
      dataElementId='cst-account-details-change-name-cancel'
    >
      <Text message='modules.crm.components.account.cancel' />
    </Button>,
    <ButtonWithLoader
      key='change-name-submit'
      type='submit'
      onClick={onSubmit}
      dataElementSuffix='account-details--change-name-submit'
      showLoader={state.isLoading}
      text={<Text message='modules.crm.components.account.submit' />}
    />
  ]

  return (
    <Modal
      actions={actions}
      dataElementPrefix='cst-account--change-name'
      disableBackdropClick
      handleClose={handleDialog}
      open={open}
      title={<Text message='modules.crm.components.account.changeName.title' />}
    >
      <div className='row'>
        <div className='col-6'>
          <TextField
            fullWidth
            className={classes.field}
            label={<Text message='modules.crm.components.account.changeName.firstName' />}
            value={firstName}
            onChange={onFirstNameChange}
            error={!!firstNameError}
            helperText={firstNameError}
            variant='outlined'
            dataElementLocation={DataElementLocations.BODY}
            dataElementLabel='cst-account-details-change-name-firstname'
            dataElementId='cst-account-details-change-name-firstname'
          />
        </div>
        <div className='col-6'>
          <TextField
            fullWidth
            className={classes.field}
            label={<Text message='modules.crm.components.account.changeName.lastName' />}
            value={lastName}
            onChange={onLastNameChange}
            error={!!lastNameError}
            helperText={lastNameError}
            variant='outlined'
            dataElementLocation={DataElementLocations.BODY}
            dataElementLabel='cst-account-details-change-name-lastname'
            dataElementId='cst-account-details-change-name-lastname'
          />
        </div>
      </div>
    </Modal>
  )
}

ChangeNameDialog.propTypes = {
  handleDialog: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired
}

export default withStyles(styles)(ChangeNameDialog)
